export function determineFiscalPeriodsFromCurrentDate() {
    /**
     * Analyze current year and quarter to determine what
     * values to pre-select in our form
     */
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentQuarter = Math.floor(now.getMonth() / 3) + 1;
    let targetYear = currentYear;
    let comparisonYear = currentYear - 1;
    let targetQuarter = currentQuarter - 1;
    let comparisonQuarter = currentQuarter - 1;
    if (targetQuarter === 0) {
        // We need to look at Q4 of the previous year
        targetQuarter = 4;
        comparisonQuarter = 4;
        targetYear--;
        comparisonYear--;
    }
    const periods = {
        target: {
            year: targetYear,
            quarter: targetQuarter,
        },
        comparison: {
            year: comparisonYear,
            quarter: comparisonQuarter,
        },
    };
    return periods;
}
export function responseContainsActualPeriodData(data) {
    return (data.actual_period &&
        Array.isArray(data.actual_period) &&
        data.actual_period.length > 0 &&
        Array.isArray(data.actual_period[0]) &&
        data.actual_period[0].length > 0);
}
